import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import _ from "lodash";
import { Subject, take, takeUntil } from "rxjs";
import { DynamicFormComponent } from "src/app/core/dynamic-form/dynamic-form.component";
import {
  DynamicFormOptions,
  FieldConfig,
  FieldTypeEnum,
} from "src/app/core/dynamic-form/dynamicForm.interface";
import { EditHistoryData } from "src/app/core/edit-history/edit-history";
import { ToastService } from "src/app/core/toast/toast.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { environment } from "src/environments/environment";

import { DynamicFormModule } from "src/app/core/dynamic-form/dynamic-form.module";
import { EditHistoryModule } from "src/app/core/edit-history/edit-history.module";
import { AdventureDto, UpdateAdventure, CreateAdventure } from "../partite-dto";
import { GestionePartiteService } from "../gestione-partite.service";
import { ClientiService } from "../../clienti/clienti.service";
import { ClientDto } from "../../clienti/clienti";
import { GenericDD } from "src/app/model/generic-data";
import { CommonModule } from "@angular/common";
import { GestioneMissioniComponent } from "../../gestione-missioni/gestione-missioni.component";
import { QRCodeComponent } from "angularx-qrcode";
import { HttpClient } from "@angular/common/http";
import { customBreadCrumbRequest } from "src/app/core/bread-crumbs/bread-crumbs.component";
import {QRCodeDto} from "../qrcode-dto";

@Component({
  selector: "app-form-partite",
  imports: [
    CommonModule,
    DynamicFormModule,
    EditHistoryModule,
    GestioneMissioniComponent,
    QRCodeComponent,
  ],
  providers: [QRCodeComponent],
  templateUrl: "./form-partite.component.html",
  styleUrl: "./form-partite.component.scss",
})
export class FormPartiteComponent implements OnInit, OnDestroy {
  @ViewChild("myForm") myForm!: DynamicFormComponent;

  @ViewChildren("qrComp", { read: ElementRef }) qrComps!: QueryList<ElementRef>;

  //DATA FROM API, THE ONE THAT GETS CHANGED AND THE OG ONE
  //CHANGE THE TYPE TO THE ONE YOU NEED
  public object?: AdventureDto;

  //ID
  codice: string = "";

  //FORM OPTIONS, DEFINED IN CONSTRUCTOR
  form2Opts: DynamicFormOptions;

  //FOR SHOWING OR HIDING FORM, USEFULL FOR REINITIALIZING
  ready: boolean = false;

  //FOR SHOWING CREATEDBY AND EDITEDBY
  editHistoryData: EditHistoryData | undefined;

  //FORM FIELDS
  regConfig2: FieldConfig[] = [];

  // current choesed qrcode
  currentQrCode: QRCodeDto | undefined;

  loadingQrCode: boolean = false;

  //NO MEMORY LEAKS FIX
  private theEnd$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute, //IF YOU USE paramMap
    private router: Router,
    private toast: ToastService,
    private gameService: GestionePartiteService,
    private clientiService: ClientiService,
    private localStorageService: LocalStorageService,
    private http: HttpClient,
    private qrCode: QRCodeComponent,
  ) {
    this.form2Opts = {
      buttonAtBottom: true, //PUT THIS ALWAYS TO MAKE BUTTON STICK TO BOTTOM
      formType: "add", //add, edit, view
      editOptions: {
        entityName: "adventure", //for lockserver apis
        entityDisplayName: "Avventura", //placeholder for messages
        deleteUrl: `${environment.apiUrl}/adventures`, //delete url
        deleteMessage: `Stai per eliminare l'avventura, procedere?`, //message on delete dialog
        deleteItem: "", //delete code/id depends, assign this when initializing form
        entityId: "", //id for lockserver apis
        isFem: true, //is fem or male?
        redirectUrl: `home/partite`, //url where it goes after delete
      },
      addOptions: {
        entityName: "adventure",
        entityDisplayName: "Avventura",
        isFem: true,
        redirectUrl: `home/partite`, //url where it goes when cancelling
      },
    };
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  //based on route decides what form to show, adapt this logic if url contains more add or edit strings
  initializeForm() {
    if (this.router.url.includes("new")) {
      this.form2Opts.formType = "add";
      this.localStorageService.setTitolo("Nuova avventura");
      this.initializeFormFields();
    } else {
      this.form2Opts.formType = "edit";
      this.form2Opts.buttonAtBottom = false;
      this.initializeEditForm();
    }
  }

  initializeFormFields() {
    this.clientiService
      .getAll()
      .pipe(take(1))
      .subscribe({
        next: (clienti: ClientDto[]) => {
          let clientsMapped: GenericDD[] = clienti.map((x) => {
            return <GenericDD>{ id: x.id, codice: x.name };
          });

          this.regConfig2 = [
            {
              type: FieldTypeEnum.input,
              name: "name",
              label: "Nome",
              isRequired: true,
              width: "w-full",
              value: this.object ? this.object.name : undefined,
              validations: [
                {
                  name: "required",
                  validator: Validators.required,
                  message: "Inserisci un nome",
                },
              ],
            },
            {
              type: FieldTypeEnum.textarea,
              name: "shortDescription",
              label: "Breve descrizione",
              isRequired: true,
              width: "w-full",
              value: this.object ? this.object.shortDescription : undefined,
              validations: [
                {
                  name: "required",
                  validator: Validators.required,
                  message: "Inserisci una breve descrizione",
                },
              ],
            },
            {
              type: FieldTypeEnum.textarea,
              name: "description",
              label: "Descrizione",
              isRequired: true,
              width: "w-full",
              value: this.object ? this.object.description : undefined,
              validations: [
                {
                  name: "required",
                  validator: Validators.required,
                  message: "Inserisci una descrizione",
                },
              ],
            },
            {
              type: FieldTypeEnum.select,
              name: "client",
              label: "Cliente",
              isRequired: true,
              width: "w-1/2",
              data: clientsMapped,
              value: this.object ? this.object.clientFk : undefined,
              validations: [
                {
                  name: "required",
                  validator: Validators.required,
                  message: "Seleziona un cliente",
                },
              ],
            },
            {
              type: FieldTypeEnum.numberInput,
              name: "maxMembers",
              label: "Dimensione squadra",
              isRequired: true,
              width: "w-full",
              data: clientsMapped,
              value: this.object ? this.object.maxMembers : 1,
              validations: [
                {
                  name: "required",
                  validator: Validators.required,
                  message: "Inserisci il numero massimo di partecipanti",
                },
                {
                  name: "min",
                  validator: Validators.min(1),
                  message: "È richiesto almeno un partecipante",
                },
              ],
            },
          ];

          if (this.form2Opts.formType == "edit") {
            this.regConfig2.push({
              type: FieldTypeEnum.select,
              name: "status",
              label: "Stato",
              isRequired: true,
              width: "w-1/2",
              data: [
                { id: "available", codice: "Disponibile" },
                { id: "not_available", codice: "Non Disponibile" },
              ],
              value: this.object ? this.object.status : undefined,
              validations: [
                {
                  name: "required",
                  validator: Validators.required,
                  message: "Seleziona uno stato",
                },
              ],
            });
          }

          this.ready = true;
        },
      });
  }

  //make api call and get data for edit
  initializeEditForm() {
    this.codice = this.route.snapshot.paramMap.get("id") || "";

    this.gameService
      .read(this.codice)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: AdventureDto) => {
          this.object = _.cloneDeep(response);
          console.warn(this.object);
          this.localStorageService.setTitolo(
            `Modifica avventura ${response.name}`,
          );

          let req: customBreadCrumbRequest = {
            oldString: response.id,
            newString: response.name,
          };
          this.localStorageService.setCustomBreadCrumb(req);

          if (this.form2Opts.editOptions) {
            this.form2Opts.editOptions.deleteItem = "" + this.object.id;
            this.form2Opts.editOptions.entityId = this.object.id;
          }

          //run this method to display form
          this.initializeFormFields();
        },
        error: () => {},
      });
  }

  goBackToGames() {
    this.router.navigate(["home/partite"]);
  }

  //fires when submitting
  submit(event: any) {
    if (this.form2Opts.formType == "add") {
      this.add(event);
    } else {
      this.edit(event);
    }
  }

  //edit submit
  edit(event: any) {
    console.log(event);
    let data: UpdateAdventure = {
      name: event.name,
      description: event.description,
      shortDescription: event.shortDescription,
      status: event.status,
      clientFk: event.client,
      maxMembers: event.maxMembers,
    };

    this.gameService
      .update(this.codice, data)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: AdventureDto) => {
          this.toast.success("Modifiche salvate");
          this.initializeForm();
        },
        error: () => {},
      });
  }

  //add submit
  add(event: any) {
    console.log(event);
    let data: CreateAdventure = {
      name: event.name,
      description: event.description,
      shortDescription: event.shortDescription,
      status: "not_available",
      clientFk: event.client,
      maxMembers: event.maxMembers,
    };

    this.gameService
      .create(data)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: AdventureDto) => {
          this.toast.success("Avventura creata");
          this.router.navigate(["home/partite", response.id]);
        },
        error: () => {},
      });
  }

  downloadQR(index: number, code: string) {
    this.loadingQrCode = true;
    const host = this.qrComps.toArray()[index]?.nativeElement as
      | HTMLElement
      | undefined;
    if (!host) return;

    const srcCanvas = host.querySelector("canvas") as HTMLCanvasElement | null;
    if (!srcCanvas) return;

    const dpr = window.devicePixelRatio || 1;

    // Dimensioni del QR (in pixel del canvas di origine)
    const qrW = srcCanvas.width;
    const qrH = srcCanvas.height;

    // Stile colori (coerente con angularx-qrcode sopra)
    const bgColor = "#1e1e1e";
    const fgColor = "#F7F737";

    // Impostazioni testo
    const padding = 16; // padding sopra/sotto il testo (in CSS px)
    let fontSize = 18; // dimensione base (CSS px)
    const fontFamily = "Inter, Arial, sans-serif";
    const text = code || "";

    // Misurazione e adattamento del font alla larghezza del QR
    const measureCtx = document.createElement("canvas").getContext("2d")!;
    const fitText = (targetWidth: number) => {
      let fs = fontSize;
      while (fs > 10) {
        measureCtx.font = `${fs * dpr}px ${fontFamily}`;
        const w = measureCtx.measureText(text).width;
        if (w <= (targetWidth - 24) * dpr) break; // 24px margine orizzontale
        fs -= 1;
      }
      return fs;
    };
    fontSize = fitText(qrW / dpr);

    // Altezze calcolate in px canvas (moltiplicate per dpr)
    const textLineHeight = Math.round(fontSize * 1.4 * dpr);
    const padPx = Math.round(padding * dpr);

    // Canvas di output (stessa larghezza del QR; altezza = QR + padding + testo + padding)
    const outCanvas = document.createElement("canvas");
    outCanvas.width = qrW;
    outCanvas.height = qrH + padPx + textLineHeight + padPx;

    const ctx = outCanvas.getContext("2d")!;
    // Sfondo
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, outCanvas.width, outCanvas.height);

    // Disegno del QR (in alto)
    ctx.drawImage(srcCanvas, 0, 0);

    // Disegno del testo centrato
    //ctx.fillStyle = fgColor;
    ctx.fillStyle = "#ffffff";
    ctx.font = `${fontSize * dpr}px ${fontFamily}`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(
      text,
      outCanvas.width / 2,
      qrH + padPx + Math.floor(textLineHeight / 2),
    );

    // Download PNG
    const dataURL = outCanvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = dataURL;
    a.download = `qr_${this.sanitizeFilename(code)}.png`;
    a.click();

    this.loadingQrCode = false;
  }

  sanitizeFilename(name: string) {
    return (name || "code")
      .replace(/[<>:"/\\|?*\x00-\x1F]/g, "_")
      .slice(0, 100);
  }
}
